/**
 * @dependencies: http://kenwheeler.github.io/slick/
 *
 * Initializes slick.js on any element with the js-carousel class.
 */

import 'slick-carousel';
import 'imagesloaded';
import modules from '../helpers/born.modules';
import {breakpoints, isRTL} from '../helpers/born.utils';
import dwUtils from '../util';

export default class Carousel {
	constructor(query) {
		let $carousels = $(query + ':not(.slick-initialized)');
			$carousels.each((index, carousel) => {

			let $carousel = $(carousel),
				carouselSettings = JSON.parse(carousel.getAttribute('data-slick'));
				
				if ( 'slidesToShow' in carouselSettings ) {
					carouselSettings.slidesToShow = parseInt(carouselSettings.slidesToShow);
				}

				if ( 'slidesToScroll' in carouselSettings ) {
					carouselSettings.slidesToShow = parseInt(carouselSettings.slidesToShow);
				}

			$carousel.imagesLoaded(() => {
				//Only add events if carousel has any video elements.
				if (carousel.querySelector('[data-video]')) {
					//Make sure video is initialized before toggling videos.
					modules.video.init();
					$carousel.on('init beforeChange', this.toggleVideo.bind(this));
				}

				carousel.slickInitialSlide = carousel.slickInitialSlide || function() {return false;};

				var inisl = carousel.slickInitialSlide($carousel) || 0;
				var isProductSize = $carousel.data('productsize');
				var isModelView = $('.results-container').data('view') === 'model-view';
				var initialSlideModel = !isProductSize && isModelView ? 1 : inisl;

				var showVidThumb = $carousel.data('video-thumb');
				if(showVidThumb !== undefined && parseInt(showVidThumb) > 0) {
					$carousel.not('.slick-initialized').slick({
						rtl: isRTL && !carouselSettings.vertical,
						initialSlide: initialSlideModel,
						customPaging:this.buildDots.bind(carousel)
					});
				} else {
					$carousel.not('.slick-initialized').slick({
						rtl: isRTL && !carouselSettings.vertical,
						initialSlide: initialSlideModel
					});
				}
				if($carousel.attr('data-slick-sync')){
					this.setupSync($carousel);
				}
           });
		});
	}

	//Determines to play/pause videos depending on the target slide
	toggleVideo(evt, $slick, slideIndex, nextSlideIndex) {

		let targetIndex = nextSlideIndex > 0 ? nextSlideIndex : 0,
			slidesToShow = $slick.slickGetOption('slidesToShow');

		[].forEach.call(Carousel.getPreviousVideos($slick.$list[0]), Carousel.pausePrevious);
		Carousel.playNext(Carousel.getNextVideos($slick.$slides[targetIndex]), $slick.$slider[0]);

		//Sometimes the slider can have more than 1 visible slide at a time (slidesToShow),
		//this makes sure all of which are played when visible
		if(slidesToShow > 1) {
			for(let index = targetIndex + 1; index < (targetIndex + slidesToShow); index++ ){
				Carousel.playNext(Carousel.getNextVideos($slick.$slides[index]), $slick.$slider[0]);
			}
		}
	}
	
	buildDots(slider, i) {
		var showVidThumb = $(this).data('video-thumb');
		var className = '';
		if(showVidThumb !== undefined && parseInt(showVidThumb) > 0 && parseInt(showVidThumb) == parseInt(i+1)) {
			className ='thumb--video';
		}
		return $('<button type="button" data-role="none" role="button" tabindex="0" class="'+className+'" />').text(i + 1);
	}
	//Get all (currently playing, if youtube) videos inside the current carousel
	static getPreviousVideos(target) {
		return target.querySelectorAll('video, .video--playing');
	}

	//Get the next visible videos from the coming slide(s)
	static getNextVideos(target) {
		return target.querySelector('[data-video]');
	}

	//Pauses all previous videos
	static pausePrevious(currentlyPlaying) {
		if( currentlyPlaying ) {
			if(currentlyPlaying.nodeName === 'VIDEO') {
				
				// disables autoplay through onScreen
				if(currentlyPlaying.video) {
					currentlyPlaying.video.videoSlideInView = false;
				}

				currentlyPlaying.pause();
			}

			else {
				currentlyPlaying.player.pauseVideo();
			}
		}
	}

	//Plays all videos inside the next slide(s)
	static playNext(targetSlideVideo, slider) {
		//Only play video if slider element is currently on viewport and it's not mobile.
		if( targetSlideVideo && window.innerWidth >= breakpoints.mobile ) {
			//Make sure the HTML video module is initialized for this to work properly
			if(targetSlideVideo.nodeName === 'VIDEO') {
				//&& !targetSlideVideo.video.manuallyPaused
				if(targetSlideVideo.video.options.playOnSlideIn) {
					// enables autoplay through onScreen
					targetSlideVideo.video.videoSlideInView = true;

					if(dwUtils.elementInViewport(slider)) {
						targetSlideVideo.play();
					}
				}
			}

			else {
				//This is very ugly but my brain is toast right now and can't think of anything else.
				let waitVideo = setInterval(() => {
					if(targetSlideVideo.player && targetSlideVideo.player.playVideo){
						clearInterval(waitVideo);
						targetSlideVideo.player.playVideo();
					}
				}, 10);
			}
		}
	}

	/**
	 * Slick doesn't provide a great method to sync sliders AND allow the slidesToScroll to be anything over 1,
	 * so this creates an alternate functionality.
	 *
	 * This also works for custom navigations, i.e. an NodeList that's not a Slick object.
	 */

	setupSync($main) {
		let scope      = this,
			$nav       = $($main.attr('data-slick-sync')),
			isSlick    = $nav.hasClass('slick-slider'),
			$navItems  = isSlick ? $($nav.slick('getSlick').$slides) : $nav.children();

		$navItems[0].classList.add('slick-nav--active');

		$main.on('beforeChange', function(evt, slick, currentSlide, nextSlide){
			scope.syncNav(nextSlide, $nav, $navItems, isSlick);
		});

		$navItems.on('click focus', function(){
			scope.syncMain.call(this, $main, $navItems);
		});
	}

	syncNav(nextSlide, $nav, $navItems, isSlick) {
		let prevSlide = $nav[0].querySelector('.slick-nav--active'),
			currSlide = $navItems[nextSlide];

		if( isSlick ){
			$nav.slick('slickGoTo', nextSlide);
		}

		prevSlide.classList.remove('slick-nav--active');
		currSlide.classList.add('slick-nav--active');
	}

	syncMain($main, $navItems) {
		let index = $navItems.index(this);

		$main.slick('slickGoTo', index);
	}
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.carousel.js